import { Shadows } from "@mui/material/styles";

/**
 * Playful's shadows are warm-tinted, never cool grey: every tint here is
 * rgba(120, 84, 40, …).
 *
 * Playful specifies three elevations, not twenty-four, so the ramp the app
 * inherited from its pre-MUI days is collapsed onto them:
 *
 *   index 1      chips, and anything else asking for the lightest lift
 *   index 2–7    cards and panels
 *   index 8–24   dialogs, menus and popovers
 *
 * The consumers inside `Override.tsx` land on the right tier by construction:
 * `MuiChip` uses `boxShadow: 1`, `MuiCard` uses `boxShadow: 2`, and
 * `PLAYFUL_SHADOW_LG` — written out longhand there for the Dialog paper — is
 * the same value as index 8.
 *
 * MUI requires exactly 25 entries.
 */

/** Lightest lift. Chips. */
const SHADOW_SM = "0 1px 4px rgba(120, 84, 40, 0.10)";
/** Cards and panels. */
const SHADOW_MD = "0 3px 10px rgba(120, 84, 40, 0.09)";
/** Floating surfaces: dialogs, menus, popovers. */
const SHADOW_LG = "0 14px 34px rgba(120, 84, 40, 0.18)";

const shadows: Shadows = [
  "none",
  SHADOW_SM,
  SHADOW_MD,
  ...(Array(5).fill(SHADOW_MD) as string[]),
  ...(Array(17).fill(SHADOW_LG) as string[]),
] as Shadows;

export default shadows;
export { SHADOW_SM, SHADOW_MD, SHADOW_LG };
